import { Theme } from '@mui/material';
import styled from '@mui/system/styled';

export const HeaderHeroWrapper = styled('div')(
  ({
    theme,
    backgroundimageurl
  }: {
    theme?: Theme;
    backgroundimageurl: { mobile: string; desktop: string };
  }) => ({
    backgroundImage: `url(${backgroundimageurl.mobile})`,
    height: '200px',
    backgroundPosition: '0 35%',
    minHeight: '200px',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    position: 'relative',
    display: 'inline-block',
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      backgroundImage: `url(${backgroundimageurl.desktop})`,
      height: '540px',
      backgroundPosition: 'top'
    },
    [theme.breakpoints.up('md')]: {
      height: '645px',
      minHeight: '220px'
    }
  })
);

export const HeaderBanner = styled('div')(({ theme }: { theme?: Theme }) => ({
  fontSize: '12px',
  textTransform: 'uppercase',
  backgroundColor: theme.palette.secondary.main,
  color: theme.palette.primary.contrastText,
  textAlign: 'center',
  padding: '5px 0',
  lineHeight: 1,
  [theme.breakpoints.up('md')]: {
    fontSize: '16px',
    lineHeight: 1.1
  }
}));
